import styles from "./HistoryDetailDialog.module.scss";
import { AppDialog } from "../AppDialog/AppDialog";
import { IconType } from "../../icons/Icon";
import { useApiQuery } from "../../infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../infrastructure/routes/endpointsMetadata";
import { IUserAuditLogDetail } from "./models/historyModels";

interface IHistoryDetailDialogProps {
  detailId: number;
  visible: boolean;
  onHide: () => void;
  detailEndpoint?: string;
}

function prettyJson(raw: string | null | undefined): string {
  if (!raw) return "";
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

export const HistoryDetailDialog = ({
  detailId,
  visible,
  onHide,
  detailEndpoint = endpointsMetadata.userAuditLog.getDetail,
}: IHistoryDetailDialogProps) => {
  const { data: detail, isLoading } = useApiQuery<IUserAuditLogDetail>({
    queryKey: [detailEndpoint, detailId],
    endpoint: `${detailEndpoint}?detailId=${detailId}`,
    enabled: visible && detailId > 0,
    disableErrorToast: false,
    retry: false,
    globalIsLoading: false,
  });

  const requestJson = prettyJson(detail?.requestBody);
  const responseJson = prettyJson(detail?.responseBody);

  return (
    <AppDialog
      header="Детайли на действието"
      headerIconType={IconType.Information}
      headerIconColor="#6366f1"
      visible={visible}
      onHide={onHide}
      style={{ maxWidth: "720px", width: "100%" }}
    >
      <div className={styles.content}>
        {isLoading && (
          <div className={styles.loading}>Зареждане...</div>
        )}

        {!isLoading && detail && (
          <>
            <div className={styles.meta}>
              {detail.httpMethod && (
                <span className={styles.meta_tag}>
                  <span className={styles.meta_tag_label}>Метод</span>
                  {detail.httpMethod}
                </span>
              )}
              {detail.endpoint && (
                <span className={styles.meta_tag}>
                  <span className={styles.meta_tag_label}>Endpoint</span>
                  {detail.endpoint}
                </span>
              )}
            </div>

            <div className={styles.panels}>
              <div className={styles.panel}>
                <span className={styles.panel_label}>Заявка (Request)</span>
                {requestJson ? (
                  <pre className={styles.panel_code}>{requestJson}</pre>
                ) : (
                  <span className={styles.empty_json}>Няма данни</span>
                )}
              </div>

              <div className={styles.panel}>
                <span className={styles.panel_label}>Отговор (Response)</span>
                {responseJson ? (
                  <pre className={styles.panel_code}>{responseJson}</pre>
                ) : (
                  <span className={styles.empty_json}>Няма данни</span>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </AppDialog>
  );
};
